import formConstants from "../../../../constants/form.constants";
import FormComponent from "../../../../components/shared/form-component/index";
import {connect, useSelector} from "react-redux";
import {updateLeadTimeOptionsFormStateValues} from "../../../../store/actions/lead-time-options.action";

const LeadTimeOptionFormItem = ({idx, updateLeadTimeOptionsFormStateValues}) => {

    const handleChange = ({name, value}) => {
        updateLeadTimeOptionsFormStateValues({
            del: deletes,
            update: updates.map((v) => ({
                ...v,
                [name]: v.idx === idx ? value : v[name],
            }))
        });
    }

    const handleRemove = () => {
        // item at idx has id => it will be deleted from the DB else just filter it out
        const deletedRow = updates.find(input => input.idx === idx);
        updateLeadTimeOptionsFormStateValues({
            del: deletedRow.id ? [...deletes, deletedRow.id] : deletes,
            update: updates.filter(input => input.idx !== idx)
        });
    }


    const {updates, deletes, formFields, isEditing} = useSelector(({leadTimeOptionsState}) => {
        const values = leadTimeOptionsState.leadTimeOptionsInputs.update.find(item => item.idx === idx);
        return {
            updates: leadTimeOptionsState.leadTimeOptionsInputs.update,
            deletes: leadTimeOptionsState.leadTimeOptionsInputs.del,
            isEditing: leadTimeOptionsState.isEditing,
            formFields: [{
                ...formConstants.fullName,
                name: 'name',
                label: 'Name',
                value: values.name,
                onChange: handleChange,
                placeholder: 'Name',
                span: 8,
            }, {
                ...formConstants.fullName,
                name: 'description',
                label: 'Description',
                value: values.description,
                onChange: handleChange,
                placeholder: 'description',
                span: 12,
            }, {
                label: 'Remove',
                onClick: handleRemove,
                fieldType: formConstants.fieldTypes.Button,
                type: 'danger',
                hide: !leadTimeOptionsState.isEditing,
                span: 4,
            }]
        }
    })

    return (
        <div>
            <FormComponent formFields={formFields} viewOnly={!isEditing}/>
        </div>
    )
}

export default connect(null, {
    updateLeadTimeOptionsFormStateValues,
})(LeadTimeOptionFormItem);
